import React from 'react'
import a1 from "../im/ava.png"
import  Records from "./top_creators.json"


// items
import item1 from '../im/items/featured-item-1.png';

import item2 from '../im/items/featured-item-2.png';
import item3 from '../im/items/featured-item-3.png';
import item4 from '../im/items/featured-item-4.png';
import item5 from '../im/items/featured-item-5.png';
import item6 from '../im/items/featured-item-6.png';
import item7 from '../im/items/featured-item-7.png';
import item8 from '../im/items/featured-item-8.png';
import item9 from '../im/items/featured-item-9.png';
import item10 from '../im/items/featured-item-10.png';
import item11 from '../im/items/featured-item-11.png';
import item12 from '../im/items/featured-item-12.png';
import item13 from '../im/items/featured-item-13.png';
import item14 from '../im/items/featured-item-14.png';
import item15 from '../im/items/featured-item-15.png';
import item16 from '../im/items/featured-item-16.png';
import item17 from '../im/items/featured-item-17.png';
import item18 from '../im/items/featured-item-18.png';
import item19 from '../im/items/featured-item-19.png';
import item20 from '../im/items/featured-item-20.png';
import item21 from '../im/items/featured-item-21.png';
import item22 from '../im/items/featured-item-22.png';
import item23 from '../im/items/featured-item-23.png';
import item24 from '../im/items/featured-item-24.png';

// avatar
import a2 from '../im/avatarr/avatar-2.png';
import a3 from '../im/avatarr/avatar-3.png';
import a4 from '../im/avatarr/avatar-4.png';
import a5 from '../im/avatarr/avatar-5.png';
import a6 from '../im/avatarr/avatar-6.png';
import a7 from '../im/avatarr/avatar-7.png';
import a8 from '../im/avatarr/avatar-8.png';
import a9 from '../im/avatarr/avatar-9.png';
import a10 from '../im/avatarr/avatar-10.png';
import a11 from '../im/avatarr/avatar-11.png';
import a12 from '../im/avatarr/avatar-12.png';
import a13 from '../im/avatarr/avatar-13.png';
import a14 from '../im/avatarr/avatar-14.png';
import a15 from '../im/avatarr/avatar-15.png';




function Top_creaters() {
    return (
        <div className='text-light '>
            <h1 className='display-5 fw-bolder headd p-5 '> 
                <span className='text-light'>Top </span> 
                <span className='text-primary'> Crea</span>
                <span className='text-info'>tors</span>
            </h1>

        {
            Records.map (record => {
                const profile = record.profile;
                return (
                    <div   className='col-sm-12 col-lg-6  col-md-12 mt-3  d-inline-block p-4'>

                <span class="badge rounded-pill badge-notification bg-dark mt-1 align-self-end  hover-overlay border border-muted p-2" > 02 </span>
                
<div className=''>

                    <div className='col border border-muted rounded-9 p-2'>


                        <div className='row'>
                            <div className='col-lg-5 col-sm-12 col-md-5 p-3  '>
                                <div className='row'>

                                <div className='col-sm-12  col-lg-4  col-md-4 '>
                                
                                    <img class="avatar avatar-64 bg-primary rounded-circle text-white p-1"
                                        src={record.profile} /><a href="">

                                        <span class="badge rounded-pill badge-notification bg-primary mt-5   "><i class="fas fa-check  "></i>  </span>

                                    </a>

                                </div>

                                <div className='col-sm-12 col-lg-8 mt-1 col-md-8'>
                                    <h5 className='top-creator-name'>
                                    {record.name}
                                    </h5>
                                    <h6 className='top-creator-handle'>
                                    {record.username}
                                    </h6>

                                </div>
                                </div>




                            </div>

                            <div className='col-lg-2 col-sm-12  col-md-2  align-self-center'>




                                <h6><span className='fw-bolder '> {record.postCount}</span></h6>

                                <h6><span className='fw-bolder '>Created</span></h6>

                            </div>


                            <div className='col-lg-5 col-md-5  p-3'>

                                <span class="avatar avatar-64 bg-secondary text-white rounded-2 "> <img src={item4} className=''></img></span>
                                <span class="avatar avatar-64 bg-secondary text-white rounded-2 mx-3 "> <img src={item5} className=''></img></span>

                                <span class="avatar avatar-64 bg-secondary text-white rounded-2  "> <img src={item6} className=''></img></span>
                            </div>
                        </div>
                    </div>

                </div>
                </div>
                )
            })
        }
 </div >
    )
}

export default Top_creaters
